export default __webpack_public_path__ + "static/media/thermometer.cb1d81ae.png";